(function ($) {
	'use strict';

	var THEMENAME = {

		init: function () {
			this.mainMenuBlock();
			this.submenuOpener();
			this.fixedHeader();
			this.footermenuOpener();
			this.pillsOpener();
			this.projectSlider();
			this.testimonialSlider();
			this.topicsSlider();
			this.rangeSLider();
			// this.lottieAnimation();
			// this.lottieAnimation1();
		},



		mainMenuBlock: function () {
			jQuery('header').on('click', '.navbar-toggle-btn', function (e) {
				e.preventDefault();
				if (!jQuery(this).hasClass("nav-open")) {
					jQuery('#navbar').removeClass('active');
					jQuery('html').removeClass('menu-active');
					jQuery(this).removeClass('nav-close').addClass('nav-open');
					//         jQuery('header').removeClass('nav-close').addClass('nav-open');

				} else {
					jQuery('#navbar').addClass('active');
					jQuery('html').addClass('menu-active');
					jQuery(this).removeClass('nav-open').addClass('nav-close');
				}

			});
		},

		submenuOpener: function () {
			jQuery(".navbar-nav .submenu-opener").on('click', function (e) {
				// e.preventDefault();
				if (!jQuery(this).hasClass('closed')) {
					jQuery(this).addClass('closed');
					jQuery(this).next('ul.dropdown-menu').slideToggle();
				}
				else {
					jQuery(this).removeClass('closed');
					jQuery(this).next('ul.dropdown-menu').slideToggle();
				}

			});

		},

		fixedHeader: function () {
			jQuery(window).scroll(function () {
				var sticky = jQuery('header'),
					scroll = jQuery(window).scrollTop();

				if (scroll >= 30) {
					sticky.addClass('sticky-header');
					jQuery('.header-top').slideUp()
				}
				else {
					sticky.removeClass('sticky-header');
					jQuery('.header-top').slideDown()
				}
			});
		},

		footermenuOpener: function () {
			jQuery(".single-menu-col .menu-heading").on('click', function (e) {
				// e.preventDefault();
				if (!jQuery(this).hasClass('opened')) {
					jQuery(this).addClass('opened');
					jQuery(this).next('ul').slideToggle();
				}
				else {
					jQuery(this).removeClass('opened');
					jQuery(this).next('ul').slideToggle();
				}

			});

		},

		pillsOpener: function () {
			jQuery('.pills-opener').on('click', function () {

				jQuery('.pills-tab-wrapper').toggleClass('open-navpills');

			});

			jQuery('.pills-tab-wrapper a.nav-link').on('click', function () {

				jQuery('.pills-tab-wrapper').removeClass('open-navpills');

			});
		},

		testimonialSlider: function () {
			$('.testimonial-slider').slick({
				dots: true,
				infinite: true,
				speed: 1000,
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				autoplay: true,
				autoplaySpeed: 10000,
			});
		},

		topicsSlider: function () {
			$('.related-topics-slider').slick({
				dots: false,
				infinite: true,
				speed: 1000,
				slidesToShow: 3,
				slidesToScroll: 1,
				arrows: true,
				autoplay: true,
				autoplaySpeed: 5000,
				responsive: [
					{
						breakpoint: 991,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2
						}
					}, ,
					{
						breakpoint: 767,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1
						}
					},
				]
			});
		},

		projectSlider: function () {
			mobileOnlySlider(".project-platform-slider-row", true, false, 991);

			function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint) {
				var slider = $($slidername);
				var settings = {
					mobileFirst: true,
					dots: $dots,
					arrows: $arrows,
					autoplay: true,
					autoplaySpeed: 10000,
					responsive: [
						{
							breakpoint: $breakpoint,
							settings: "unslick"
						},
						{
							breakpoint: 767,
							settings: {
								slidesToShow: 2,
								slidesToScroll: 2
							}
						}, ,
						{
							breakpoint: 0,
							settings: {
								slidesToShow: 1,
								slidesToScroll: 1
							}
						},
					]
				};

				slider.slick(settings);

				$(window).on("resize", function () {
					if ($(window).width() > $breakpoint) {
						return;
					}
					if (!slider.hasClass("slick-initialized")) {
						return slider.slick(settings);
					}
				});
			} // Mobile Only Slider
		},


		rangeSLider: function () {

            const settings = {
                fill: '#044BEA',
                background: '#D8DEFF'
            }


            const sliders = document.querySelectorAll('.range-slider');


            Array.prototype.forEach.call(sliders, (slider) => {

                slider.querySelector('input').addEventListener('input', (event) => {

                    slider.querySelector('span').innerHTML = event.target.value;

                    applyFill(event.target);
                });

                applyFill(slider.querySelector('input'));
            });


            function applyFill(slider) {

                const percentage = 100 * (slider.value - slider.min) / (slider.max - slider.min);

                const bg = `linear-gradient(90deg, ${settings.fill} ${percentage}%, ${settings.background} ${percentage + 0.1}%)`;
                slider.style.background = bg;
            }


        },

		lottieAnimation : function () {
			
			jQuery(".lottie-animation").length && jQuery(".lottie-animation").each(function ()

			{

				var e = jQuery(this).attr("data-json");

				e && lottie.loadAnimation(

					{

						container: document.querySelectorAll(".lottie-animation")[0],

						renderer: "svg",

						loop: !0,

						autoplay: !0,

						path: e

					})

			})
			
		},

		lottieAnimation1 : function () {
			
			jQuery(".lottie-animation1").length && jQuery(".lottie-animation1").each(function ()

			{

				var e = jQuery(this).attr("data-json");

				e && lottie.loadAnimation(

					{

						container: document.querySelectorAll(".lottie-animation1")[0],

						renderer: "svg",

						loop: !0,

						autoplay: !0,

						path: e

					})

			})
			
		},




	};

	THEMENAME.init();

})(jQuery);

